if (!customElements.get('naturalistic-mobile-buy')) {
  customElements.define('naturalistic-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.action = this.querySelector('[data-nb-buy-button]');
      this.price = this.querySelector('[data-nb-buy-price]');
      this.sync = this.update.bind(this);
      this.handleClick = () => {
        const form = document.getElementById(this.dataset.formId);
        const submit = form?.querySelector('[name="add"]');
        const variant = form?.querySelector('[name="id"]');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || !variant?.value || variant.disabled) return;
        form.requestSubmit(submit);
      };
      this.action.addEventListener('click', this.handleClick);
      this.scope?.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      if (this.scope) this.observer.observe(this.scope, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled','value']});
      const nativeButton = document.getElementById(this.dataset.formId)?.querySelector('[name="add"]');
      this.nativeVisible = false;
      this.visibility = new IntersectionObserver(entries => {
        this.nativeVisible = entries[0].isIntersecting;
        this.update();
      });
      if (nativeButton) this.visibility.observe(nativeButton);
      this.update();
    }
    update() {
      const form = document.getElementById(this.dataset.formId);
      const submit = form?.querySelector('[name="add"]');
      const variant = form?.querySelector('[name="id"]');
      const available = Boolean(submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true' && variant?.value && !variant.disabled);
      if (this.action.disabled === available) this.action.disabled = !available;
      const label = submit?.querySelector('span')?.textContent?.trim() || '';
      if (label && this.action.textContent !== label) this.action.textContent = label;
      const price = this.scope?.querySelector('[id^="price-"] .price');
      const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular')?.textContent?.trim() || '';
      const choices = [...(this.scope?.querySelectorAll('variant-selects input:checked, variant-selects select option:checked') || [])].filter(choice => !choice.name?.startsWith('Scent-')).map(choice => choice.value).filter(value => value && value !== 'Default Title');
      const summary = [amount, ...choices].join(' · ');
      if (this.price.textContent !== summary) this.price.textContent = summary;
      const shouldHide = this.nativeVisible || !submit || Boolean(this.closest('quick-add-modal'));
      if (this.hidden !== shouldHide) this.hidden = shouldHide;
      document.documentElement.classList.toggle('nb-mobile-buy-active', !this.hidden);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.visibility?.disconnect();
      this.scope?.removeEventListener('change', this.sync);
      this.action?.removeEventListener('click', this.handleClick);
      document.documentElement.classList.remove('nb-mobile-buy-active');
    }
  });
}
